import { LoanStatus } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { GetLoanDetailActionsByRoleProps } from '@/components/widgets/LoanDetailActions/types/GetLoanDetailActionsByRoleProps';
import { LoanDetailAction } from '@/components/widgets/LoanDetailActions/types/LoanDetailAction';
import { APP_ROLES } from '@/config/config';

export const getLoanFormalizationRelatedActions = ({
  toggleActionDialog,
  loan,
  role,
}: GetLoanDetailActionsByRoleProps) => {
  if (!(role === APP_ROLES.ADMIN || role === APP_ROLES.SUPER_ADMIN || role === APP_ROLES.CPC_BACK_OFFICE)) return [];

  if (loan.status === LoanStatus.STATUS_CONTRACT_SIGNED)
    return [
      {
        display: <Text tId={'FORMALIZE_APPLICATION'} />,
        onClick: () => toggleActionDialog(LoanDetailAction.FORMALIZE_APPLICATION),
        iconName: 'done_all',
      },
    ];
  if (loan.status === LoanStatus.STATUS_DOCS_APPROVED)
    return [
      {
        display: <Text tId={'MARK_LOAN_AS_PAID'} />,
        onClick: () => toggleActionDialog(LoanDetailAction.MARK_LOAN_AS_PAID),
        iconName: 'paid',
      },
    ];
  return [];
};
